import { Users, Briefcase } from 'lucide-react'

export function SegmentedToggle({ segment, onChange }) {
  const isRetail = segment === 'retail'

  return (
    <div
      className="relative flex items-center rounded-full border border-brand-slate/30 bg-white p-1"
      role="tablist"
      aria-label="Select shopping segment"
    >
      <button
        type="button"
        role="tab"
        aria-selected={isRetail}
        onClick={() => onChange('retail')}
        className={`relative z-10 flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-all duration-200 ${
          isRetail ? 'text-brand-navy' : 'text-brand-slate hover:text-brand-ink'
        }`}
      >
        <Users className="h-4 w-4" />
        Retail
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={!isRetail}
        onClick={() => onChange('wholesale')}
        className={`relative z-10 flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-all duration-200 ${
          !isRetail ? 'text-brand-navy' : 'text-brand-slate hover:text-brand-ink'
        }`}
      >
        <Briefcase className="h-4 w-4" />
        Wholesale
      </button>
      <span
        className="pointer-events-none absolute left-1 top-1 h-[calc(100%-8px)] w-[calc(50%-4px)] rounded-full bg-brand-gold/15 transition-transform duration-200"
        style={{ transform: isRetail ? 'translateX(0)' : 'translateX(100%)' }}
      />
    </div>
  )
}
